export const CHECKOUT_DRAFT_PARAM = 'draft';
export const CHECKOUT_FRAME_PARAM = 'frame';
/** `frame` value for a work the customer has chosen to leave unframed. */
export const CHECKOUT_UNFRAMED = 'none';
export const CHECKOUT_PRIVATE_PARAM = 'private';
export const CHECKOUT_VARIANT_PARAM = 'variant';
export const CHECKOUT_WORKS_PARAM = 'works';

export const MIN_QUANTITY = 1;
export const MAX_QUANTITY = 10;
